import type { AppThunk } from "@Store/index";
import { fetchUniversityPageDataIfNeeded } from "./universityPageReducer";

const loadData = (props: any): AppThunk[] => [fetchUniversityPageDataIfNeeded(props)];

export default loadData;
